import * as React from 'react';
import { useObservable } from 'react-use-observable';

import { useQuery } from '@tanstack/react-query';
import { IS_PROD } from 'settings';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import tokenService from 'v2/services/token';

function QualificationValidation() {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [accountsId] = useObservable(() => tokenService.getAccountsId(), []);
  const [accesses] = useObservable(() => eduzzAccountsService.getAccesses(), []);
  const canShowQualification = !!user?.acceptence_terms;
  const hasPendingQualification = useQuery({
    queryKey: ['qualificationRedirect'],
    queryFn: () => eduzzAccountsService.checkPendingQualification(user.id),
    enabled: !!accountsId && canShowQualification,
    gcTime: 0
  });

  const redirectUserToQualification = React.useCallback((accountId: string, qualificationUrl: string) => {
    const params = `?userId=${accountId}&utm_source=myeduzz`;
    qualificationUrl = !IS_PROD
      ? qualificationUrl.replace('qualificacao.eduzz.com/', 'qualificacao.eduzz.com/version-test/')
      : qualificationUrl;
    window.location.href = `${qualificationUrl}${params}`;
  }, []);

  React.useEffect(() => {
    if (!user || !accesses) return;
    if (!canShowQualification) return;
    if (user.is_support || hasPendingQualification.isLoading) return;
    if (!accesses.some(item => item.id === user.id && item.isMe === true)) return; // only account owners should respond to the qualification

    const shouldRedirect = hasPendingQualification.data && hasPendingQualification.data.pendingQualificationUrl;

    if (shouldRedirect) {
      redirectUserToQualification(accountsId, hasPendingQualification.data.pendingQualificationUrl);
    }
  }, [redirectUserToQualification, accountsId, user, hasPendingQualification, accesses, canShowQualification]);

  if (!user) return null;

  return <></>;
}

export { QualificationValidation };
